<bdsp-simple-page>

  <!-- Top Panel -->
  <div class="top-panel">
    <top-nav></top-nav>
  </div>

  <!-- Content Panel -->
  <div class="content-panel bds-bg-grays-gray-100">

    <!-- Home Content -->
    <div class="
      bds-p-64">
      <div class="bds-text-large bds-pb-64">
        BWO Copilot Prototype
      </div>

      <div class="
        bds-flexbox 
        bds-flex-row
        bds-gap-64">
        <div class="use-case-ux">
          <!-- START BWO Copilot MVP -->
          <div id="rwu_help-panel" style="width: 423px">

            <!-- rwu_help-panel-header-->
            <div class="rwu_help-panel-header">
              <div class="rwu_help-panel-header-controls">
                <div class="header-control">
                  <hrb-icon name="arrow-left"></hrb-icon>
                </div>
                <hrb-nav-secondary>
                  <hrb-nav-secondary-item
                    icon="search"
                    icon-position="right"
                    link-text="Search..."
                  >
                  </hrb-nav-secondary-item>
                  <hrb-nav-secondary-item
                    icon="edit"
                    icon-position="right"
                    link-text="Report new issue"
                  >
                  </hrb-nav-secondary-item>
                </hrb-nav-secondary>
                <div class="header-control">
                  <hrb-icon name="close"></hrb-icon>
                </div>
              </div>
              <div class="rwu_help-panel-header-input">
                <hrb-input
                  label="Search..."
                  placeholder="Zip code"
                ></hrb-input>
                <hrb-button icon="arrow-right"></hrb-button>
              </div>
            </div>

            <!-- rwu_help-panel-result-summary-->
            <div class="rwu_help-panel-result-summary">
              <div class="
                bds-flexbox
                bds-flex-row
                bds-justify-between
                bds-mb-24
                bds-text-neons-neon-hrb">
                <div>
                  <svg width="90" height="24" viewBox="0 0 90 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.19942 1.34005C9.51343 0.466863 10.7441 0.455071 11.0748 1.32208L13.5999 7.94283C13.7028 8.2125 13.9172 8.42458 14.1879 8.52456L17.9576 9.91656C18.8338 10.2401 18.8275 11.4816 17.948 11.7962L14.2254 13.1279C13.9331 13.2324 13.7059 13.4668 13.6106 13.7623L11.0926 21.5643C10.7918 22.4963 9.46932 22.4852 9.18422 21.5483L6.81788 13.7718C6.72629 13.4708 6.49838 13.2305 6.20267 13.1231L2.54604 11.7946C1.67281 11.4773 1.66645 10.2446 2.53636 9.91836L6.23912 8.52971C6.51397 8.42663 6.72965 8.20801 6.82898 7.93178L9.19942 1.34005Z" fill="#00E95C"/>
                    <path d="M17.9277 13.2765C18.095 12.8661 18.6738 12.8601 18.8497 13.2668L20.2606 16.53C20.3146 16.655 20.4173 16.7526 20.545 16.8001L22.722 17.611C23.1583 17.7735 23.1552 18.3918 22.7172 18.5498L20.5495 19.332C20.4192 19.379 20.3142 19.478 20.2596 19.6054L18.8504 22.8953C18.6753 23.3041 18.0937 23.298 17.9271 22.8857L16.6048 19.6115C16.5519 19.4805 16.4459 19.3779 16.3132 19.3293L14.1839 18.549C13.749 18.3896 13.7458 17.7757 14.179 17.6119L16.3178 16.8028C16.4478 16.7536 16.5515 16.6526 16.6039 16.5239L17.9277 13.2765Z" fill="#00E95C"/>
                    <path d="M34.6063 16L37.5583 7.42H38.9263L41.8303 16H40.7983L39.9583 13.528H36.4183L35.5903 16H34.6063ZM38.1943 8.284L36.7063 12.7H39.6823L38.1943 8.284ZM43.5202 16V7.42H44.5642V16H43.5202ZM51.7041 16.108C50.5401 16.108 49.6161 15.544 49.6161 14.26C49.6161 12.808 51.1521 12.316 52.7601 12.316H53.6601V11.86C53.6601 10.864 53.2761 10.444 52.3161 10.444C51.4521 10.444 50.9721 10.804 50.8761 11.572H49.8801C50.0121 10.144 51.1521 9.616 52.3641 9.616C53.5641 9.616 54.6561 10.108 54.6561 11.86V16H53.6601V15.208C53.1921 15.796 52.6281 16.108 51.7041 16.108ZM51.8001 15.316C52.8561 15.316 53.6601 14.776 53.6601 13.804V13.024H52.7961C51.5361 13.024 50.6121 13.336 50.6121 14.26C50.6121 14.908 50.9241 15.316 51.8001 15.316ZM56.7326 16V9.724H57.7286V10.72C58.0166 10.132 58.7126 9.616 59.7446 9.616C61.0406 9.616 61.9526 10.324 61.9526 12.148V16H60.9566V12.076C60.9566 10.972 60.4886 10.48 59.4806 10.48C58.5566 10.48 57.7286 11.068 57.7286 12.196V16H56.7326ZM65.9685 16.108C64.4685 16.108 63.5685 15.352 63.5085 14.068H64.4805C64.5525 14.812 64.9485 15.28 65.9565 15.28C66.9045 15.28 67.3245 14.956 67.3245 14.284C67.3245 13.624 66.8325 13.408 65.8605 13.228C64.2285 12.928 63.6765 12.472 63.6765 11.38C63.6765 10.216 64.8165 9.616 65.8005 9.616C66.9285 9.616 67.9005 10.072 68.0685 11.428H67.1085C66.9645 10.744 66.5805 10.444 65.7885 10.444C65.0685 10.444 64.6005 10.804 64.6005 11.344C64.6005 11.908 64.9125 12.136 66.0645 12.34C67.3605 12.58 68.2725 12.868 68.2725 14.2C68.2725 15.34 67.4925 16.108 65.9685 16.108ZM71.1115 16L69.1795 9.724H70.2595L71.7235 14.776L73.2475 9.724H74.1115L75.5395 14.776L77.0155 9.724H78.0355L76.0795 16H74.9755L73.6675 11.296L72.2035 16H71.1115ZM81.9497 16.108C80.1737 16.108 78.9137 14.86 78.9137 12.928V12.832C78.9137 10.936 80.1257 9.616 81.8537 9.616C83.3057 9.616 84.6737 10.492 84.6737 12.736V13.06H79.9457C79.9937 14.488 80.6777 15.28 81.9617 15.28C82.9337 15.28 83.4977 14.92 83.6297 14.188H84.6257C84.4097 15.448 83.3657 16.108 81.9497 16.108ZM79.9817 12.256H83.6537C83.5577 10.96 82.8857 10.444 81.8537 10.444C80.8337 10.444 80.1497 11.14 79.9817 12.256ZM86.322 16V9.724H87.318V10.852C87.714 10.144 88.254 9.652 89.382 9.616V10.552C88.122 10.612 87.318 11.008 87.318 12.556V16H86.322Z" fill="#F6F4E9"/>
                  </svg>
                </div>
                <div class="
                  bds-flexbox
                  bds-flex-row
                  bds-items-center">
                  <div class="
                    bds-text-body-support">
                    What's this?
                  </div>
                  <div class="bds-flexbox bds-align-center">
                    <hrb-icon name="error"></hrb-icon>
                  </div>
                </div>
              </div>
              <h2 class="bds-text-medium bds-mb-24">Summary</h2>
              <div class="bds-text-body-regular">There are three Known Issues in AMP related to zip codes. In some cases the zip code is not populating, or certain zip code formats are not accepted. These issues may not be resolved this season, but they have manual workarounds. Expand the Known Issues below to see if this resolves your issue.</div>
            </div>

            <div class="rwu_help-panel-result-issues">
              <h2 class="bds-text-small bds-mb-24">3 Known Issues for "Zip Code"</h2>
              <hrb-accordion class="bds-text-body-regular">
                <hrb-accordion-item
                  id="openItem"
                  header-text="BW Online - 2023 - MD 502S"
                  subnav-header-style="standard">
                  <div 
                  class="bds-pb-24">
                    State: Maryland Form: 502S
                    <br />
                    If the zip code is not auto populating the project city and state.
                    <h3 class="bds-text-body-medium">Workaround:</h3>
                    Manually enter the city and state information on the input screen.

                    <hrb-button
                      full-width
                      theme="secondary"
                      class="bds-mt-16">
                      Subscribe for updates
                    </hrb-button>
                  </div>
                </hrb-accordion-item>
                <hrb-accordion-item
                  id="openItem"
                  header-text="OCE-BWO - 2023 - FD - 1065-Sch K1"
                  subnav-header-style="standard">
                  <div 
                  class="bds-pb-24">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ac nisi placerat, commodo nibh quis, eleifend velit. Vivamus consequat in nulla nec convallis. Suspendisse laoreet ex et lorem venenatis laoreet.

                    <hrb-button
                      full-width
                      theme="secondary"
                      class="bds-mt-16">
                      Subscribe for updates
                    </hrb-button>
                  </div>
                </hrb-accordion-item>
                <hrb-accordion-item
                  id="openItem"
                  header-text=" NY - IT-201 or 203 - NY GI Page - Permanent Zip code"
                  subnav-header-style="standard">
                  <div 
                  class="bds-pb-24">
                    State: Maryland Form: 502S
                    <br />
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ac nisi placerat, commodo nibh quis, eleifend velit. Vivamus consequat in nulla nec convallis. Suspendisse laoreet ex et lorem venenatis laoreet.

                    <hrb-button
                      full-width
                      theme="secondary"
                      class="bds-mt-16">
                      Subscribe for updates
                    </hrb-button>
                  </div>
                </hrb-accordion-item>
              </hrb-accordion>
              <div class="
                rwu_help-panel-report-issue
                bds-flexbox
                bds-flex-row
                bds-justify-between
                bds-py-24
                bds-mt-24">
                <div class="
                  bds-flexbox
                  bds-flex-row
                  bds-align-center
                  bds-items-center
                  bds-gap-8">
                  <hrb-icon name="edit"></hrb-icon>
                  <div class="bds-text-body-regular">Report new issue</div>
                </div>
                <hrb-icon name="chevron-right"></hrb-icon>
              </div>
            </div>

          </div>
          <!-- END BWO Copilot MVP -->
        </div>
        <div class="ptl-use-case-description">
          <h2 class="
            bds-text-medium
            bds-mb-16">Use Case</h2>
          <p class="
            bds-text-body-support
            bds-mb-16">
            The BWO team approached the BDS team for UX support on their Copilot MVP.  The Copilot will feature a panel that opens from the right side of the main content.  We first demonstrated use of <i>&lt;hrb-modal&gt;</i> for this.  However, <i>&lt;hrb-modal&gt;</i> creates a flyover which overlays the content beneath.  The BWO team then specified that as the Copilot panel opens, it must push the main content over to make room.
          </p>
          <p class="
            bds-text-body-support
            bds-mb-16">
            We mentioned <i>&lt;hrb-drawer&gt;</i> as a possible solution, but with the caveat that it is not a fully supported BDS component.  So instead, it was agreed that we would coach the BDS dev in how to structure the HTML and CSS in order to achieve the required behavior.
          </p>
          <p class="
            bds-text-body-support
            bds-mb-16">
            From there, given the time constraint, we created the UX for the panel within the Portal sandbox, as seen here.  During the process, we learned that BWO runs version 1.1 of the BDS.  As a result, not all BDS components were available for the project.  One example is <i>&lt;hrb-input-group&gt;</i>, the preferred solution for the Search field.  We encouraged the BWO team to update to the latest version of the BDS in the near future.
          </p>
          <p class="
            bds-text-body-support
            bds-mb-16">
            With UX development complete, we handed off the HTML and CSS snippets for integration into the BWO Copilot MVP.  Successive consultation helped move the BWO team closer to a finished prototype UX within their demo environment.
          </p>
        </div>
      </div>

    </div>
   
  </div>

</bdsp-simple-page>